/*eslint-disable */
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactCanvasConfetti from "react-canvas-confetti";
import { useRef } from "react";
import { Modal, Button, Typography } from "antd";
import { Dropdown, Modal as MModal, Nav, Tab } from "react-bootstrap";

import "./redeem.css";
import { Beatloader } from "../components/Spinner";
import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
} from "@material-ui/icons";
import AnimatedNumbers from "react-animated-numbers";
import RedeemService from "../services/Redeem.service";
import {
  FailedNotification,
  SuccessNotifation,
} from "../components/Notifications";

import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import Skeleton from "react-loading-skeleton";
import ScrollingText from "../components/ScrollingText";
import { ToastContext } from "../hooks/ToastContext";
import { debounce } from "lodash";

import myBackground from "../assets/img/GC_logo_new-01.png";
import "./GiftCardRedemptionModal.css";
import { UserContext } from "../hooks/UserContext";

const canvasStyles = {
  position: "fixed",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  zIndex: 9999,
};

function formatNumberWithCommas(number) {
  return number.toLocaleString("en-US");
}

export default function Redeem() {
  const { handleToastState } = useContext(ToastContext);

  const { currentUser } = useContext(UserContext);

  const showToast = () => {
    handleToastState(true); // Set toast as active
    // Logic to display the toast
  };

  const dismissToast = () => {
    handleToastState(false); // Set toast as inactive
    // Logic to dismiss the toast
  };

  const [modal, setModal] = useState(false);

  const refAnimationInstance = useRef(null);

  const GC = 500;

  const [isLoading, setIsLoading] = useState(false);

  const [MyPoints, setMyPoints] = useState({
    totalReward: 0,
    totalRemaining: 0,
  });

  const [convRate, setConvRate] = useState(1);

  const convertPointsToRupees = (points) => {
    const rupeesValue = points / convRate; // 1000 points equal 1 rupee
    return rupeesValue;
  };

  const convertRupeesToPoints = (points) => {
    const pointValue = points * convRate; // 1000 points equal 1 rupee
    return pointValue;
  };

  const [redeemLoading, setRedeemLoading] = useState(false);

  const [toggleSpinner, settoggleSpinner] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    RedeemService.getRate()
      .then((response) => {
        console.log("json3:", response.data);
        setConvRate(response.data.in_points);
      })
      .catch((error) => {
        console.error(error.message);
      });

    RedeemService.getPoints(currentUser.id)
      .then((response) => {
        console.log("json3:", response.data);
        setMyPoints(response.data);
      })
      .catch((error) => {
        console.error(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (redeemLoading === false) {
      fetchData();
    }
  }, [redeemLoading]);

  const updatedMyPoints = {
    ...MyPoints,
    totalRemainingWorth: convertPointsToRupees(MyPoints.totalRemaining),
  };

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const makeShot = useCallback((particleRatio, opts) => {
    refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        origin: { y: 0.7 },
        particleCount: Math.floor(200 * particleRatio),
      });
  }, []);

  const [isLoadingeCards, setIsLoadingeCards] = useState(true);

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
    });

    makeShot(0.2, {
      spread: 200,
    });

    makeShot(0.35, {
      spread: 200,
      decay: 0.91,
      scalar: 0.8,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }, [makeShot]);

  const [number, setNumber] = useState(1);
  /* eslint-disable */
  const [reedemAmount, setRedeemAmount] = useState(500);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setNumber(newValue);
    setRedeemAmount(GC * newValue);
  };

  // useEffect(() => {}, [reedemAmount]);

  const { confirm } = Modal;

  const [eCardItems, setECardItems] = useState([]);

  const handleChangePage = (event, newPage) => {
    console.log("handleChangePage: ", newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function showConfirm() {
    confirm({
      title: "Confirmation",
      content: `Do you wish to proceed with redeeming gift card's with a deduction of ${(
        parseInt(value, 10) * 100
      ).toLocaleString("en-US")} points ?`,
      async onOk() {
        try {
          console.debug("im here");
          await RedeemService.availGC(
            value,
            selectedItem,
            1,
            skuDetails["raw_data"]["name"]
          )
            .then((response) => {
              // Call your function here when the promise is resolved
              fire();
              console.log(response);
              SuccessNotifation(response.data, showToast, dismissToast);
            })
            .catch((error) => {
              if (error.response) {
                // The request was made and the server responded with a status code >= 400
                console.error("Error:", error.response.data);
                console.error("Status Code:", error.response.status);
                FailedNotification(
                  error.response.data.detail,
                  showToast,
                  dismissToast
                );
              } else if (error.request) {
                // The request was made but no response was received
                console.error("No response received:", error.request);
              } else {
                // Something else happened while setting up the request
                console.error("Error:", error.message);
              }
            })
            .finally(() => {
              setRedeemLoading(false);
              settoggleSpinner(false);
              setFocusedIndex(null);
              setModal((current) => !current);
              setSelectedItem(null);
              setSkuDetails(null);
              setIsChecked(false);
            });

          // return new Promise((resolve, reject) => {
          //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
          // })
          //   .then(() => {
          //     //

          //     setRedeemLoading(false);

          //     // Call your function here when the promise is resolved
          //     fire();
          //   })
          //   .catch((error) => {
          //     // Handle the  rejection of the promise here if needed
          //     console.error("Promise rejected:", error);
          //   });
        } catch (e) {
          return console.log("Oops errors!: ", e);
        }
      },
      onCancel() {
        settoggleSpinner(false);
        setRedeemLoading(false);
      },

      width: "50%", // Set the width to 100% of the parent container
      height: "100vh", // Set the height to 100% of the viewport height
      zIndex: 10000,
    });
  }

  useEffect(() => {
    console.log("II");
  }, [modal]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRedeem = () => {
    // Set redeemLoading to true when you start the redeem operation
    setRedeemLoading(true);

    // showConfirm();
    setIsModalOpen(true);

    // // Simulate an async operation (e.g., an API request)
    // setTimeout(() => {
    //   // After the operation is complete, set redeemLoading back to false
    //   setRedeemLoading(false);
    // }, 2000); // Replace this with the actual duration of your operation
  };

  // TODO: Call API to get points details

  // TODO: Call API to reedem points

  const [focusedIndex, setFocusedIndex] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (event.target.checked) {
      setShowError(false);
    }
  };

  const handleProceedClick = (event) => {
    if (!isChecked) {
      setShowError(true);
      event.preventDefault();
    } else {
      // Proceed with form submission or other actions

      settoggleSpinner(true);
      handleRedeem();
    }
  };

  // const handleCardClick = (index) => {
  //   console.log("Clicked");
  //   setFocusedIndex(index);
  // };

  const [selectedItem, setSelectedItem] = useState(null);
  const [skuDetails, setSkuDetails] = useState(null);

  const [error, setError] = useState("");
  const [value, setValue] = useState("100");

  const [searchText, setSearchText] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const handleChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(searchText);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchText]);

  const handleTextChange = (text) => {
    setValue(text);
  };
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);

  const [showecards, setShowecards] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [totalItems, setTotalItems] = useState(0); // Add state for total items

  const fetchDataeCards = async () => {
    setIsLoading(true);
    try {
      const response = await RedeemService.getAmazonProducts(
        page + 1,
        rowsPerPage,
        debouncedValue
      );
      setECardItems(response.data.items);
      console.debug("debug products:", response.data.items);
      setTotalItems(response.data.total);
      // setWasLastList(response.data.items.length < pageSize);
    } catch (error) {
      console.error("Error fetching banners:", error);

      if (error.response) {
        // The request was made and the server responded with a status code >= 400
        console.error("Error:", error.response.data);
        console.error("Status Code:", error.response.status);
        FailedNotification(error.response.data.detail, showToast, dismissToast);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
      } else {
        // Something else happened while setting up the request
        console.error("Error:", error.message);
        FailedNotification(error.message, showToast, dismissToast);
      }
    } finally {
      setIsLoading(false);
      setIsLoadingeCards(false);
    }
  };

  useEffect(() => {
    if (!showecards) {
      fetchDataeCards();
    }
  }, [page, showecards, debouncedValue, rowsPerPage, modal]);

  useEffect(() => {
    console.log("II");
    if (!modal === (showecards || !showecards)) {
      setCurrPage(1);
      setPrevPage(0);
      setECardItems([]);
      // setWasLastList(false);
    }
  }, [showecards, modal]);

  useEffect(() => {
    if (value === "") {
      setError(" Denomination is required.");
    } else if (!/^\d*$/.test(value)) {
      setError(" Denomination must be a whole number.");
    } else {
      const number = parseInt(value, 10);
      if (number < 100 || number > Number(skuDetails?.raw_data?.price.max)) {
        setError(
          `Denomination must be between ${"100".toLocaleString(
            "en-IN"
          )} and ${skuDetails?.raw_data?.price.max.toLocaleString("en-US")}.`
        );
      } else {
        setError("");
      }
    }
  }, [value]);
  const handleClose = () => {
    settoggleSpinner(false);
    setFocusedIndex(null);
    setModal((current) => !current);
    setSelectedItem(null);
    setValue("100");
  };

  const tableIcons = {
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
  };

  const handleShow = (index, each) => {
    console.log("open modal");
    setFocusedIndex(index);
    setModal((current) => !current);
    setSelectedItem(each["sku"]);
    setSkuDetails(each);
  };

  const { Title, Paragraph, Text } = Typography;
  const [isLoadingConfirmation, setIsLoadingConfirmation] = useState(false);

  const OnCanelRedeem = () => {
    settoggleSpinner(false);
    setRedeemLoading(false);
    setIsModalOpen(false);
  };

  const onConfirmReedem = async () => {
    try {
      console.debug("im here");
      await RedeemService.availGC(
        value,
        selectedItem,
        1,
        skuDetails["raw_data"]["name"]
      )
        .then((response) => {
          // Call your function here when the promise is resolved
          fire();
          console.log(response);
          SuccessNotifation(response.data, showToast, dismissToast);
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code >= 400
            console.error("Error:", error.response.data);
            console.error("Status Code:", error.response.status);
            FailedNotification(
              error.response.data.detail,
              showToast,
              dismissToast
            );
          } else if (error.request) {
            // The request was made but no response was received
            console.error("No response received:", error.request);
          } else {
            // Something else happened while setting up the request
            console.error("Error:", error.message);
          }
        })
        .finally(() => {
          setRedeemLoading(false);
          settoggleSpinner(false);
          setFocusedIndex(null);
          setModal(false);
          setSelectedItem(null);
          setSkuDetails(null);
          setIsChecked(false);
          setIsLoadingConfirmation(false);
          setIsModalOpen(false);
        });

      // return new Promise((resolve, reject) => {
      //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
      // })
      //   .then(() => {
      //     //

      //     setRedeemLoading(false);

      //     // Call your function here when the promise is resolved
      //     fire();
      //   })
      //   .catch((error) => {
      //     // Handle the  rejection of the promise here if needed
      //     console.error("Promise rejected:", error);
      //   });
    } catch (e) {
      return console.log("Oops errors!: ", e);
    }
  };

  return (
    <div style={{ height: "100vh" }}>
      <Modal
        open={isModalOpen}
        title={<Title level={3}>Confirmation</Title>}
        footer={null}
        height={"100vh"}
        zIndex={10000}
        onCancel={OnCanelRedeem}
        onClose={OnCanelRedeem}
        closable={false}
        maskClosable={false}
      >
        <div className="redemption-info">
          <Paragraph className="points-info">
            Points to be deducted:{" "}
            <Text strong className="points-info">
              {(parseInt(value, 10) * 100).toLocaleString("en-US")}
            </Text>
          </Paragraph>
        </div>

        <div className="confirmation-question">
          <Paragraph style={{ fontSize: "16px", fontWeight: "bold" }}>
            Do you wish to proceed with redeeming this gift card?
          </Paragraph>
        </div>

        <div className="tax-info">
          <Title level={4}>Tax Information</Title>
          <Paragraph>
            Gifts from employers are tax-free if their total value in a year is
            up to Rs. 15,000. If the total exceeds Rs. 15,000, the entire amount
            is taxable under Section 17(2) as part of Income from salary at slab
            rates applicable to you.
          </Paragraph>
        </div>

        <div className="action-buttons">
          <Button
            className="cancel-button"
            onClick={OnCanelRedeem}
            disabled={isLoadingConfirmation}
          >
            Cancel
          </Button>

          {isLoadingConfirmation ? (
            <button className="btn add-btn">
              <Beatloader />
            </button>
          ) : (
            <button
              onClick={async () => {
                setIsLoadingConfirmation(true);
                setModal(false);

                await onConfirmReedem();
              }}
              className="btn add-btn"
            >
              Yes, Redeem
            </button>
          )}
        </div>

        <div className="contact-info">
          <Paragraph>
            Need more information? Contact{" "}
            <a href="mailto:accounts.eits@evolutyz.com">
              accounts.eits@evolutyz.com
            </a>
          </Paragraph>
        </div>
      </Modal>

      <MModal
        show={modal}
        onHide={handleClose}
        // backdrop="static"
        keyboard={false}
        className="modal-right-wider"
      // style={{
      //   zIndex: 9999,
      // }}
      >
        <div className="modal-header ">
          <h4 style={{ color: "#f58b29" }}>{skuDetails?.raw_data?.name}</h4>

          <button
            type="button"
            className="close"
            onClick={handleClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          {/* <div dangerouslySetInnerHTML={{ __html: skuDetails?.tnc?.content }} /> */}

          <div
            style={{
              paddingTop: "4%",
              paddingBottom: "1%",
            }}
          >
            <div
              style={{
                backgroundImage: `url(${myBackground})`,
                width: "270px",
                height: "150px",
                borderRadius: "20px",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "20px",
                border: "1px solid #000",
              }}
            ></div>
          </div>

          <small>Validity: 12 Months from the date of Activation</small>

          <div
            className="align-items-left justify-content-center flex-column"
            style={{
              paddingTop: "4%",
              paddingBottom: "4%",
            }}
          >
            <h5>Description:</h5>
            <div
              name="sel_reward_applicable"
              style={{
                // height: "200px",
                overflowY: "auto",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            >
              {skuDetails?.raw_data?.description}
            </div>
          </div>

          {skuDetails?.raw_data?.price?.type === "RANGE" && (
            <div className="label-float">
              <input
                style={{
                  width: "100%",
                  borderBottom: error ? "2px solid red" : "2px solid #f58b29",
                }}
                required
                type="text"
                min={0}
                value={value}
                onChange={(e) => handleTextChange(e.target.value)}
              />

              <h5>
                Enter denomination:
                <span style={{ color: "red" }}>{error && error}</span>
              </h5>
              <div
                style={{
                  paddingTop: "1%",
                  fontSize: "10px",
                  color: "#f58b29",
                }}
              >
                {`Min:100.00 Max: ₹${skuDetails?.raw_data?.price.max.toLocaleString(
                  "en-IN"
                )}.00`}
              </div>
            </div>
          )}

          <div
            className="align-items-left justify-content-center flex-column"
            style={{
              paddingTop: "4%",
              paddingBottom: "4%",
            }}
          >
            <h5>
              {skuDetails?.raw_data?.price?.type === "RANGE" && "or "}
              Choose:
            </h5>

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {skuDetails?.raw_data?.price?.denominations &&
                (false
                  ? skuDetails.raw_data.price.denominations
                  : [100, 500]
                ).map(
                  (each, index) =>
                    each >= 100 && (
                      <button
                        key={index}
                        style={{
                          marginRight: "10px",
                          marginBottom: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          border:
                            value === each.toString()
                              ? "1px solid black"
                              : "1px solid #f58b29", // Change color if selected
                          borderRadius: "10px",
                          backgroundColor:
                            value === each.toString() ? "#ff9b44" : "#f0f0f0", // Change color if selected
                          cursor: "pointer",
                          color: value === each.toString() ? "black" : "gray", // Change text color if selected
                        }}
                        onClick={() => handleTextChange(each.toString())}
                      >
                        ₹{each.toLocaleString("en-US")}
                      </button>
                    )
                )}
            </div>
          </div>
        </div>

        <div className="modal-footer text-center align-items-center justify-content-center flex-column">
          <div className="w-100 text-left d-flex align-items-start">
            <label>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                style={{
                  borderColor: showError ? "red" : "initial", // Change border color if error
                  borderWidth: showError ? "2px" : "initial",
                  borderStyle: showError ? "solid" : "none",
                }}
              />

              <span className="ml-2">
                I agree to the{" "}
                <a href={`${skuDetails?.raw_data?.tnc?.link}`} target="_blank">
                  Terms & Conditions
                </a>
              </span>
            </label>
          </div>
          {/* <button className="btn btn-primary submit-btn" onClick={notify} >Save</button> */}
          {toggleSpinner ? (
            <button
              // onClick={handleClick}
              className="btn add-btn"
            // disabled
            >
              <Beatloader />
            </button>
          ) : (
            <button
              onClick={handleProceedClick}
              className="btn add-btn"
              disabled={
                !isChecked ||
                value.trim() === "" ||
                Number(value) <= 99 ||
                Number(value) > 10000
              }
            >
              Proceed
            </button>
          )}
        </div>
      </MModal>
      <div className="page-wrapper" style={{ backgroundColor: "white" }}>
        <div className="content">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Redeem</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/home">
                      <span>
                        <i className="la la-home"></i> Home
                      </span>
                    </Link>
                  </li>

                  <li className="breadcrumb-item active">
                    <i className="las la-coins"></i> Redeem
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <ScrollingText />
            </div>
          </div>
          {/* Cards */}

          <div className="row justify-content-center mb-5">
            {/* <div className="col-md-4">
              <div
                className="card mb-0"
                style={{
                  borderRadius: 10,
                  borderColor: "#f58b29",
                  backgroundColor: "#fff",
                  opacity: 0.7,
                  boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)", // Define the box shadow here
                }}
              >
                <div className="card-body">
                  <div className="row" style={{ fontSize: 20, color: "gray" }}>
                    <div className="col">
                      <span>Points Earned</span>
                    </div>
                  </div>
                  <div className="row" style={{ fontSize: 30 }}>
                    <div className="col d-flex align-items-center justify-content-left">
                      <span>
                        <i
                          className="las la-coins"
                          style={{
                            color: "gold",
                          }}
                        ></i>
                      </span>

                      <AnimatedNumbers
                        includeComma
                        animateToNumber={updatedMyPoints.totalReward}
                        locale="en-IN"
                        configs={[
                          { mass: 1, tension: 220, friction: 100 },
                          { mass: 1, tension: 180, friction: 130 },
                          { mass: 1, tension: 280, friction: 90 },
                          { mass: 1, tension: 180, friction: 135 },
                          { mass: 1, tension: 260, friction: 100 },
                          { mass: 1, tension: 210, friction: 180 },
                        ]}
                      ></AnimatedNumbers>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-md-4">
              <div
                className="card mb-0"
                style={{
                  borderRadius: 10,
                  borderColor: "#f58b29",
                  backgroundColor: "#fff",
                  opacity: 0.7,
                  boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)", // Define the box shadow here
                }}
              >
                <div className="card-body">
                  <div className="row" style={{ fontSize: 20, color: "gray" }}>
                    <div className="col">
                      <span> Available Points</span>
                    </div>
                  </div>
                  <div className="row" style={{ fontSize: 30 }}>
                    <div className="col d-flex align-items-center justify-content-left">
                      <span>
                        <i
                          className="las la-coins"
                          style={{
                            color: "green",
                          }}
                        ></i>
                      </span>
                      <AnimatedNumbers
                        includeComma
                        animateToNumber={MyPoints.totalRemaining}
                        locale="en-US"
                        configs={[
                          { mass: 1, tension: 220, friction: 100 },
                          { mass: 1, tension: 180, friction: 130 },
                          { mass: 1, tension: 280, friction: 90 },
                          { mass: 1, tension: 180, friction: 135 },
                          { mass: 1, tension: 260, friction: 100 },
                          { mass: 1, tension: 210, friction: 180 },
                        ]}
                      ></AnimatedNumbers>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="card mb-0"
                style={{
                  borderRadius: 10,
                  borderColor: "#f58b29",
                  backgroundColor: "#fff",
                  opacity: 0.7,
                  boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)", // Define the box shadow here
                }}
              >
                <div className="card-body">
                  <div className="row" style={{ fontSize: 20, color: "gray" }}>
                    <div className="col">
                      <span> Points Worth</span>
                    </div>
                  </div>
                  <div className="row" style={{ fontSize: 30 }}>
                    <div className="col d-flex align-items-center justify-content-left">
                      <span>
                        <i
                          className="las la-rupee-sign"
                          style={{
                            color: "green",
                          }}
                        ></i>
                      </span>
                      <AnimatedNumbers
                        includeComma
                        animateToNumber={updatedMyPoints.totalRemainingWorth}
                        locale="en-US"
                        configs={[
                          { mass: 1, tension: 220, friction: 100 },
                          { mass: 1, tension: 180, friction: 130 },
                          { mass: 1, tension: 280, friction: 90 },
                          { mass: 1, tension: 180, friction: 135 },
                          { mass: 1, tension: 260, friction: 100 },
                          { mass: 1, tension: 210, friction: 180 },
                        ]}
                      ></AnimatedNumbers>
                    </div>
                  </div>

                  {/* <ul
                    className="star-list position-absolute mb-1 ml-4"
                    style={{ bottom: 0, left: 0 }}
                  >
                    <li style={{ color: "green" }}>
                      {`₹ 
                        ${parseInt(
                          updatedMyPoints.totalRemainingWorth,
                          10
                        ).toLocaleString("en-IN")}
                        `}
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          {/* <div
            className="row mx-auto mt-5 mb-5 w-75"
            style={{
              minHeight: "150px",
              borderRadius: 20,
              boxShadow: "6px 6px 6px #f0f0f0",
            }}
          >
            <div
              className="col-md-6"
              style={{
                // backgroundImage:
                //   "linear-gradient(to right, rgb(243, 122, 65), rgb(255 175 46))",

                border: "1px solid #ff9b44",
                alignItems: "center",
                justifyContent: "center",
                borderTopLeftRadius: 20,
                borderBottomLeftRadius: 20,
              }}
            >
              <div className="position-relative h-100 text-center d-flex text-black">
                <i
                  className="las la-coins align-icon"
                  style={{
                    color: "green",
                  }}
                ></i>
                <h2 className="position-relative m-auto" style={{ zIndex: 1 }}>
                  <AnimatedNumbers
                    fontStyle={{ color: "green" }}
                    includeComma
                    animateToNumber={MyPoints.totalRemaining}
                    locale="en-IN"
                    configs={[
                      { mass: 1, tension: 220, friction: 100 },
                      { mass: 1, tension: 180, friction: 130 },
                      { mass: 1, tension: 280, friction: 90 },
                      { mass: 1, tension: 180, friction: 135 },
                      { mass: 1, tension: 260, friction: 100 },
                      { mass: 1, tension: 210, friction: 180 },
                    ]}
                  ></AnimatedNumbers>
                </h2>
                <p
                  className="position-absolute mb-2"
                  style={{
                    bottom: 0,
                    left: "50%",
                    marginLeft: "-5em",
                    fontSize: 10,
                  }}
                >
                  Available Points
                </p>
              </div>
            </div>

            <div
              className="col-md-6 d-flex"
              style={{
                borderTopRightRadius: 20,
                borderBottomRightRadius: 20,
                border: "1px solid #ff9b44",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="position-relative h-100 text-center d-flex text-black">
                <i
                  className="las la-rupee-sign align-icon"
                  style={{
                    color: "green",
                  }}
                ></i>
                <h2 className="position-relative m-auto" style={{ zIndex: 1 }}>
                  <AnimatedNumbers
                    includeComma
                    fontStyle={{ color: "green" }}
                    animateToNumber={updatedMyPoints.totalRemainingWorth}
                    locale="en-IN"
                    configs={[
                      { mass: 1, tension: 220, friction: 100 },
                      { mass: 1, tension: 180, friction: 130 },
                      { mass: 1, tension: 280, friction: 90 },
                      { mass: 1, tension: 180, friction: 135 },
                      { mass: 1, tension: 260, friction: 100 },
                      { mass: 1, tension: 210, friction: 180 },
                    ]}
                  ></AnimatedNumbers>
                </h2>
                <p
                  className="position-absolute mb-2"
                  style={{
                    bottom: 0,
                    left: "50%",
                    marginLeft: "-5em",
                    fontSize: 10,
                  }}
                >
                  Points Worth
                </p>
              </div>
            </div>
          </div> */}

          <div className="row justify-content-between mb-4 align-items-center">
            <div className="col-sm-6 col-md-8">
              <h3>Redeem your points by selecting an Amazon gift card:</h3>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="top-nav-search position-relative form-focus">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  value={searchText}
                  onChange={handleChange}
                  style={{ borderColor: "#ff9b44" }} // Inline style for border color
                />
                <button className="btn" type="submit">
                  <i className="fa fa-search" style={{ color: "#ff9b44" }}></i>
                </button>
              </div>
            </div>
          </div>

          {/* Field and reddeem */}
          {/* <div className="row">
            <div className="col">
              <h3>Redeem your points</h3>
            </div>
          </div> */}
          {/* <div className="row">
            <div className="col">
              <div className="GC-card-body"></div>
            </div>
          </div> */}
          {/* <div className="row">
            <div className="col-md-12">
              <div className="card mb-0">
                <div className="card-body">
                  <div
                    className="row"
                    style={{
                      alignItems: "center",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                    }}
                  >
                    <div className="col-md-10">
                      <div
                        className="row"
                        style={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                          marginLeft: 10,
                        }}
                      >
                        <div
                          className="GC-card-body"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <div className="GC-line-2">
                            <span className="GC-num">₹500</span>
                          </div>
                        </div>

                        <span
                          style={{
                            marginRight: 15,
                            marginLeft: 15,
                            color: "#000",
                          }}
                        >
                          X
                        </span>

                        <div style={{ width: "8%" }}>
                          <input
                            style={{ borderColor: "#000" }}
                            type="number"
                            className="form-control"
                            min="1"
                            max={Math.floor(
                              updatedMyPoints.totalRemainingWorth / GC
                            )}
                            value={number}
                            onChange={handleInputChange}
                          />
                        </div>

                        <span style={{ marginRight: 10, marginLeft: 10 }}>
                          =
                        </span>

                        <div
                          className="card mb-0"
                          style={{
                            borderRadius: 10,
                            backgroundColor: "#fff",
                            opacity: 0.7,
                            borderColor: "#069557",
                          }}
                        >
                          <div className="col btn">
                            <span>
                              <i
                                className="las la-rupee-sign"
                                style={{ color: "#069557", fontSize: "1em" }}
                              ></i>
                            </span>
                            <span style={{ color: "#069557", fontSize: "1em" }}>
                              {formatNumberWithCommas(reedemAmount)}
                            </span>
                          </div>
                        </div>

                        <div
                          className="card mb-0"
                          style={{
                            marginLeft: 10,
                            borderRadius: 10,
                            backgroundColor: "#fff",
                            opacity: 0.7,
                            borderColor: "#ff9b44",
                          }}
                        >
                          <div className="col btn ">
                            <span>
                              <i
                                className="las la-coins"
                                style={{ color: "#ff9b44", fontSize: "1em" }}
                              ></i>
                            </span>
                            <span style={{ color: "#ff9b44", fontSize: "1em" }}>
                              {formatNumberWithCommas(
                                convertRupeesToPoints(reedemAmount)
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2">
                      {redeemLoading ? (
                        <button
                          style={{ width: "100%", borderRadius: 50 }}
                          type="button"
                          className="btn btn-primary"
                          disabled
                        >
                          <Beatloader />
                        </button>
                      ) : (
                        <button
                          style={{ width: "100%", borderRadius: 50 }}
                          type="button"
                          onClick={handleRedeem}
                          className="btn btn-primary"
                          disabled={
                            updatedMyPoints.totalRemaining <
                            convertRupeesToPoints(GC)
                          }
                        >
                          Redeem Points
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {isLoadingeCards ? (
            <div className="row">
              {Array.from({ length: 8 }).map((_, index) => (
                <div className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 ">
                  <div key={index} style={{ marginBottom: "30px" }}>
                    <Skeleton height={110} />
                  </div>
                </div>
              ))}
            </div>
          ) : eCardItems.length > 0 ? (
            <div className="row">
              {eCardItems.map((each, index) => (
                <div className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 ">
                  <div
                    key={index}
                    className={`GC-card-body ${focusedIndex === index ? "focused" : ""
                      }`}
                    onClick={() => {
                      handleShow(index, each);
                    }}
                    style={{
                      backgroundColor: "#fff",
                      // border: "1px solid #ddd",
                      padding: "10px",
                      cursor: "pointer",
                      // backgroundImage: `url("${each?.raw_data?.images?.thumbnail}")`,
                      height: "150px",
                      border: "1px solid #f58b29",
                    }}
                  >
                    <span className="GC-num">
                      {each?.raw_data?.name?.length > 30
                        ? `${each?.raw_data?.name.substring(0, 30)}...`
                        : each?.raw_data?.name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "40vh",
              }}
            >
              <p>No eCards to show</p>
            </div>
          )}

          {totalItems > 7 && (
            <div
              className="pagination-wrapper"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                marginTop: "2rem",
                marginBottom: "1rem",
              }}
            >
              <Fragment>
                <div className="TablePaginationIntroductionDemo">
                  <table aria-label="custom pagination table">
                    <tfoot>
                      <tr>
                        <TablePagination
                          className="CustomTablePagination"
                          rowsPerPageOptions={[8, 16, 24, 32]}
                          colSpan={3}
                          count={totalItems}
                          rowsPerPage={rowsPerPage}
                          labelRowsPerPage="Cards per page:"
                          page={0}
                          slotProps={{
                            select: {
                              "aria-label": "Rows per page",
                            },
                            actions: {
                              showFirstButton: true,
                              showLastButton: true,
                              slots: {
                                firstPageIcon: tableIcons.FirstPage,
                                lastPageIcon: tableIcons.LastPage,
                                nextPageIcon: tableIcons.NextPage,
                                backPageIcon: tableIcons.PreviousPage,
                              },
                            },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <Styles />
              </Fragment>
            </div>
          )}
        </div>
      </div>
      {/* <Modal
          show={true}
          // onHide={handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
          centered
          style={{
            zIndex: 9999,
          }}
        >
          <div className="modal-content p-2">
            <div className="modal-heading">
              <h2 style={{ color: "#069557" }}>{"Confirmation"}</h2>
            </div>

            <div className="modalBody">
              <div>{`Do you wish to proceed with redeeming gift card's with a deduction of  `}</div>

              <span>
                <i className="las la-coins" style={{ color: "#f58b29" }}></i>
              </span>

              <div>{` ${(number * 500 * convRate).toLocaleString(
                "en-IN"
              )} points ?`}</div>
            </div>

            <div className="modal-footer text-center"></div>
          </div>
        </Modal> */}
      <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />
    </div>
  );
}

const cyan = {
  50: "#E9F8FC",
  100: "#BDEBF4",
  200: "#99D8E5",
  300: "#66BACC",
  400: "#1F94AD",
  500: "#0D5463",
  600: "#094855",
  700: "#063C47",
  800: "#043039",
  900: "#022127",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

function Styles() {
  // Replace this with your app logic for determining dark mode

  return (
    <style>
      {`
      .TablePaginationIntroductionDemo {
        width: 500px;
        max-width: 100%;
      }

      th {
        background-color: "#fff"};
      }

      .TablePaginationIntroductionDemo table {
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 0.875rem;
        width: 100%;
        box-shadow: 0px 4px 16px ${grey[200]};
        background-color:"#fff"};
        border: 1px solid ${grey[200]};
        border-radius: 12px;
        overflow: hidden;
      }

      .TablePaginationIntroductionDemo td,
      .TablePaginationIntroductionDemo th {
        padding: 16px;
      }

      .TablePaginationIntroductionDemo th {
        background-color: ${"#fff"};
      }

      .CustomTablePagination .${classes.spacer} {
        display: none;
      }

      .CustomTablePagination .${classes.toolbar}  {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;

        @media (min-width: 768px) {
          flex-direction: row;
          align-items: center;
        }
      }

      .CustomTablePagination .${classes.selectLabel} {
        margin: 0;
      }

      .CustomTablePagination .${classes.select} {
        font-family: 'IBM Plex Sans', sans-serif;
        padding: 2px 0 2px 4px;
        border: 1px solid ${grey[200]};
        border-radius: 6px;
        background-color: transparent;
        color: ${grey[900]};
        transition: all 100ms ease;
      }

      .CustomTablePagination .${classes.select}:hover {
        background-color: ${grey[50]};
        border-color: ${grey[300]};
      }

      .CustomTablePagination .${classes.select}:focus {
        outline: 3px solid ${cyan[200]};
        border-color: ${cyan[500]};
      }

      .CustomTablePagination .${classes.displayedRows} {
        margin: 0;

        @media (min-width: 768px) {
          margin-left: auto;
        }
      }

      .CustomTablePagination .${classes.actions} {
        display: flex;
        gap: 6px;
        border: transparent;
        text-align: center;
      }

      .CustomTablePagination .${classes.actions} > button {
        display: flex;
        align-items: center;
        padding: 0;
        border: transparent;
        border-radius: 50%;
        background-color: transparent;
        border: 1px solid ${grey[200]};
        color: ${grey[900]};
        transition: all 120ms ease;

        > svg {
          font-size: 22px;
        }
      }

      .CustomTablePagination .${classes.actions} > button:hover {
        background-color: ${grey[50]};
        border-color: ${grey[300]};
      }

      .CustomTablePagination .${classes.actions} > button:focus {
        outline: 3px solid ${cyan[200]};
        border-color: ${cyan[500]};
      }

      .CustomTablePagination .${classes.actions} > button:disabled {
        opacity: 0.3;
      }

      .CustomTablePagination .${classes.actions} > button:disabled:hover {
        border: 1px solid ${grey[200]};
        background-color: transparent;
      }
      `}
    </style>
  );
}
